// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#contactPage {
    min-height: calc(100vh - 4rem);
    width: 100vw;
    max-width: 60rem;
    margin: 0 auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.contactPageTitle {
    font-size: 3rem;
    margin-bottom: 1rem;
}

.clientDesc {
    font-weight: 300;
    font-size: 1rem;
}

.clientImgs {
    margin: 1rem 0;
    display: flex;
    flex-wrap: wrap;
}

.clientImg {
    object-fit: cover;
    width: 23%;
    min-width: 9rem;
    margin: auto;
    padding: 0.25rem;
}

#clients {
    padding: 2rem;
}

.contactDesc {
    padding: 1rem;
    font-size: medium;
    font-weight: 300;
}

.contactForm {
    margin: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 90vw;
    max-width: 60rem;
}

.name, .email, .msg {
    font-size: medium;
    width: 100%;
    max-width: 40rem;
    margin: 0.5rem;
    padding: 0.5rem 1rem;
    color: white;
    border: none;
    border-radius: 0.5rem;
    background: rgb(40, 40, 40);
}

.submitBtn {
    background: white;
    border: none;
    border-radius: 0.5rem;
    margin: 2rem;
    padding: 0.75rem 3.5rem;
}

.links {
    display: flex;
    flex-wrap: wrap;
}

.link {
    object-fit: cover;
    height: 3rem;
    width: 3rem;
    margin: 0 0.75rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Contact/contact.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB","sourcesContent":["#contactPage {\n    min-height: calc(100vh - 4rem);\n    width: 100vw;\n    max-width: 60rem;\n    margin: 0 auto;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.contactPageTitle {\n    font-size: 3rem;\n    margin-bottom: 1rem;\n}\n\n.clientDesc {\n    font-weight: 300;\n    font-size: 1rem;\n}\n\n.clientImgs {\n    margin: 1rem 0;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.clientImg {\n    object-fit: cover;\n    width: 23%;\n    min-width: 9rem;\n    margin: auto;\n    padding: 0.25rem;\n}\n\n#clients {\n    padding: 2rem;\n}\n\n.contactDesc {\n    padding: 1rem;\n    font-size: medium;\n    font-weight: 300;\n}\n\n.contactForm {\n    margin: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 90vw;\n    max-width: 60rem;\n}\n\n.name, .email, .msg {\n    font-size: medium;\n    width: 100%;\n    max-width: 40rem;\n    margin: 0.5rem;\n    padding: 0.5rem 1rem;\n    color: white;\n    border: none;\n    border-radius: 0.5rem;\n    background: rgb(40, 40, 40);\n}\n\n.submitBtn {\n    background: white;\n    border: none;\n    border-radius: 0.5rem;\n    margin: 2rem;\n    padding: 0.75rem 3.5rem;\n}\n\n.links {\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.link {\n    object-fit: cover;\n    height: 3rem;\n    width: 3rem;\n    margin: 0 0.75rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
